import { Backdrop, CircularProgress, Container, Divider, Grid } from '@material-ui/core';
import { ArrowBack, Save as SaveIcon } from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ButtonUI from '../../components/ui/ButtonUI';
import LoadingUI from '../../components/ui/LoadingUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { useAuth } from '../../hooks/auth';
import { MvnOutgoingMaterialInvoicePost } from '../../interfaces/Mvm';
import MvmApi from '../../services/MvmApi';
import permissions from '../../utils/Permissions';
import { useStyles } from './Style';
import MvmOutgoingMaterialInvoiceList from './components/MvmOutgoingMaterialInvoiceList';
import MvmSummary from './components/MvmSummary';
interface Params {
    mvmNumber: string;
}
interface IFormInput {
    mvmNumber: any;
    mvmNumberUnique: string;
    outgoingRequests: any;
}

const AddMvmOutgoingMaterialInvoice: React.FC = () => {
    const history = useHistory()
    const classes = useStyles()
    const { t } = useTranslation("Mvm")
    const { user, hasPermission } = useAuth()
    const { t: _t } = useTranslation("General")
    const { enqueueSnackbar } = useSnackbar()
    const [mvm, setMvm] = useState<any>(null)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [queryMvmId, setQueryMvmId] = useState<any>(null)
    const [outgoingMaterialInvoices, setOutgoingMaterialInvoices] = useState<any[]>([])
    const [circularLoading, setCircularLoading] = useState(false)
    const { control, handleSubmit, setValue, getValues } = useForm<IFormInput>(
    {
        defaultValues: { mvmNumber: {}, mvmNumberUnique: '' }
    })

    useEffect(() => {
        const companyId = user.company.companyID;
        if (+companyId !== 241 || !hasPermission(permissions.MVM.IncOutgoingMaterialInvoice))
            history.replace('NoPermission');

    }, [history, user]);

    useEffect(() => {
        if (!mvm)
            return

        //Preencher as descricoes de cada item da lista, para ser exibido corretamente na tela (TODO: Isto deveria ficar dentro de MvmOutgoingRequestList.)
        mvm.outgoingRequests.forEach((x: any) => {
            x['supplierName'] = x['supplierId'] + ' - ' + x['supplierCorporateName'];
            x['requestTypeDescription'] = x['outgoingRequestType'];
        });

        setValue("outgoingRequests", mvm.outgoingRequests)
        
        //Cada Shed tem uma colecao de RackLoads - esta tela deve exibir todos os racks de todos os sheds
        let rackLoads: any = [];
        mvm.sheds.forEach((x: any) => {
            //Incluir os rackLoads de cada shed na lista:
            x.rackLoads.forEach((y: any) => {         
                y.rackLoadId = y.id; //Setar este ID para obter depois, pois a propriedade "id" é sobrescrita pelo react hook form FieldArray
                rackLoads.push(y);
            });
        });

        setValue("outgoingRequests", mvm.outgoingRequests)
    }, [mvm])

    const onSummaryChange = (data: any) => {
        if (!data) {
            setMvm(null)
            return
        }

        setMvm(data)
    }

    const onSubmit = async () => {
        if (!mvm) {
            enqueueSnackbar(t("returnSearchMvmNotFoundMessage"), { variant: 'warning' })
            return
        }

        if (mvm.composition && mvm.mvmType !== 'C') {
            enqueueSnackbar(t("mvmCabinCannotContainInvoices"), { variant: 'warning' })
            return
        }

        setCircularLoading(true)

        const request: MvnOutgoingMaterialInvoicePost[] = outgoingMaterialInvoices.map((invoice: any) => {
            return {
                mvmId: invoice.mvmId,
                outgoingRequestType: invoice.outgoingRequestType,
                invoiceKey: invoice.invoiceKey,
                invoiceNumber: invoice.invoiceNumber,
            }
        })

        await MvmApi.insertOutgoingMaterialInvoice(request)
            .then(() => {
                enqueueSnackbar(_t("returnSubmitDeleteFormSuccess"), { variant: 'success' });
                window.location.reload();
            })
            .catch((res: any) => {
                enqueueSnackbar(res.message, { variant: 'error' });
            })
            .finally(() => {
                setCircularLoading(false);
            })
    }

    return (
        <Container maxWidth={false} component="main">
            <PageTitle title={t("titleOutgoingInvoiceMaterial")} />

            {
                isLoading ? <LoadingUI /> :
                (
                <div className={classes.rootContent}>
                    <form onSubmit={handleSubmit(onSubmit)} >                    
                        <Divider style={{ marginTop: '10px' }} />
                        <MvmSummary
                            control={control}
                            name={"summary"}
                            onChange={onSummaryChange}
                            setValue={setValue}
                            queryMvmId={queryMvmId}
                            includeProperties={["Sheds", "OutgoingRequests"]}
                        />
                    </form>
                        
                    {!mvm ? <></> : 
                        <Grid container spacing={1}>
                                <Backdrop style={{ zIndex: 9999 }} open={circularLoading}>
                                    <CircularProgress color="inherit" />
                                </Backdrop>
                                <Grid item xs={12}>
                                    <MvmOutgoingMaterialInvoiceList
                                        mvmId={mvm.id}
                                        mvmStatus={mvm.status}
                                        outgoingMaterialInvoices={outgoingMaterialInvoices} 
                                        setOutgoingMaterialInvoices={setOutgoingMaterialInvoices}
                                    />
                                </Grid>
                                <ButtonUI
                                    style={{ marginTop: 15 }}
                                    variant="outlined"
                                    color="secondary"
                                    onClick={() => window.location.reload()}
                                    startIcon={<ArrowBack />}>
                                    {_t("back")}
                                </ButtonUI>
                                <ButtonUI
                                    style={{ marginTop: 15, marginLeft: 15 }}
                                    variant="outlined"
                                    color="primary"
                                    onClick={() => onSubmit()}
                                    startIcon={<SaveIcon />}>
                                    {_t("save")}
                                </ButtonUI>
                        </Grid>                
                    }
                </div>
                )
            }
        </Container>
    )
}
export default AddMvmOutgoingMaterialInvoice;
